<div class="layout-footer">
  <div class="col-12 flex"
       [ngClass]="{'justify-content-between': !layoutService.isMobile, 'flex-column justify-content-center align-items-center': layoutService.isMobile}">
    <span class="footer-copyright">&#169; ServiceJan - {{currentYear}}</span>
    <span class="footer-developedBy">
      <a href="https://servicejan.com">ServiceJan.com</a> Developed by ServiceJan Inc.
    </span>
  </div>
</div>
